import { ApiEntity } from "../../Api/api.model";
import { string, type, number, enums, boolean, optional } from "superstruct";
import { validateStruct } from "../../../utils/validate";

const challengeLockComponent = "gamification.challenge";
const actionLockComponent = "gamification.action";
const scoreLockComponent = "gamification.progress";

function formatLock(locks: Array<unknown>) {
  return locks.reduce((formattedLocks, rawLock) => {
    const lockType = rawLock["__component"];
    if (lockType && lockType === challengeLockComponent) {
      formattedLocks["challengeLock"] = rawLock;
      formattedLocks["challengeLock"]["id"] = rawLock["id"].toString();
      formattedLocks["challengeLock"]["level"]["id"] =
        rawLock["level"]["id"].toString();
      formattedLocks["challengeLock"]["status"] = (
        rawLock["status"] as string
      ).toUpperCase();
    }
    if (lockType && lockType === actionLockComponent) {
      formattedLocks["actionLock"] = rawLock;
      formattedLocks["actionLock"]["id"] = rawLock["id"].toString();
      formattedLocks["actionLock"]["level"]["id"] =
        rawLock["level"]["id"].toString();
    }
    if (lockType && lockType === scoreLockComponent) {
      formattedLocks["scoreLock"] = rawLock;
      formattedLocks["scoreLock"]["id"] = rawLock["id"].toString();
      formattedLocks["scoreLock"]["level"]["id"] =
        rawLock["level"]["id"].toString();
    }
    return formattedLocks;
  }, {});
}

interface ChallengeLock {
  id: string;
  status: string;
  count: number;
  consecutive: boolean;
  level: {
    id: string;
    name: string;
  };
}

interface ScoreLock {
  id: string;
  zenPoints?: number;
  level: {
    id: string;
    name: string;
  };
}

interface ActionLock {
  id: string;
  status: string;
  count: number;
  consecutive: boolean;
  level: {
    id: string;
    name: string;
  };
}

export interface Locker {
  id: string;
  name: string;
  lock: {
    challengeLock?: ChallengeLock;
    scoreLock?: ScoreLock;
    actionLock?: ActionLock;
  };
}

const challengeLockStruct = type({
  id: string(),
  status: enums(["COMPLETED", "FAILED", "ONGOING", "RESTARTED", "RETRIED"]),
  count: number(),
  consecutive: boolean(),
  level: type({
    id: string(),
    name: string(),
  }),
});

const ActionLockStruct = type({
  id: string(),
  status: string(),
  count: number(),
  consecutive: boolean(),
  level: type({
    id: string(),
    name: string(),
  }),
});

const ScoreLockeStruct = type({
  id: string(),
  zenPoints: optional(number()),
  level: type({
    id: string(),
    name: string(),
  }),
});

const LockerStruct = type({
  id: string(),
  name: string(),
  lock: type({
    challengeLock: optional(challengeLockStruct),
    scoreLock: optional(ScoreLockeStruct),
    actionLock: optional(ActionLockStruct),
  }),
});

export class LockerEntity extends ApiEntity<Array<Locker>> {
  constructor() {
    super("lockers");
  }
  validate(rawData: Array<{}>): Array<Locker> {
    return rawData.map((rawItem) =>
      validateStruct<Locker>(rawItem, LockerStruct, this.endPoint, [
        { field: "id", transform: (id: number) => id.toString() },
        { field: "lock", transform: formatLock },
        { field: "id", transform: (id: number) => id.toString() },
      ])
    );
  }
}
